import { render, staticRenderFns } from "./StudyCard.vue?vue&type=template&id=73d779f9&scoped=true&"
import script from "./StudyCard.vue?vue&type=script&lang=js&"
export * from "./StudyCard.vue?vue&type=script&lang=js&"
import style0 from "./StudyCard.vue?vue&type=style&index=0&id=73d779f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d779f9",
  null
  
)

export default component.exports